import { useLocalObservable } from 'mobx-react-lite';

import { extractShortLanguage, getLanguageNameByCode, TLanguageCode } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { getLanguage } from 'APP/utils/getLanguage';

interface ILanguageItem {
  key: string;
  title: string;
  value: string;
  isActive: boolean;
  onChange(language: string): void;
}

interface ILanguageChangePopupPresenter {
  currentActiveLanguage: TLanguageCode;
  languageItems: ILanguageItem[];
  setActiveCurrentLanguage(value: TLanguageCode): void;
  changeAppLanguage(): void;
}

export function useLanguageChangePopupPresenter(): ILanguageChangePopupPresenter {
  const availableLaungages = PROJECT_CONFIG.availableLaungages.map((item) => {
    return extractShortLanguage(item);
  });

  const presenter = useLocalObservable(() => ({
    currentActiveLanguage: extractShortLanguage(getLanguage()) as TLanguageCode,

    get languageItems(): ILanguageItem[] {
      return availableLaungages.map((item) => {
        return {
          key: item,
          value: item,
          title: getLanguageNameByCode(item),
          onChange: presenter.setActiveCurrentLanguage,
          isActive: item === presenter.currentActiveLanguage,
        };
      });
    },

    setActiveCurrentLanguage(value: TLanguageCode): void {
      presenter.currentActiveLanguage = value;
    },

    changeAppLanguage(): void {
      Tasks.app.changeAppLanguage(presenter.currentActiveLanguage);
    },
  }));

  return presenter;
}
